import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const beneficiariesFeatureKey = 'beneficiaries';

export interface BeneficiariesState {
  loadBeneficiaries: any;
  loadBeneficiariesResponse: any;
  loadBeneficiariesFailure: any;
  deleteCharityBeneficiary?: any;
  deleteCharityBeneficiaryResponse?: any;
  deleteCharityBeneficiaryFailure?: any;
  deleteIndividualBeneficiary?: any;
  deleteIndividualBeneficiaryResponse?: any;
  deleteIndividualBeneficiaryFailure?: any;
  deleteTrustBeneficiary?: any;
  deleteTrustBeneficiaryResponse?: any;
  deleteTrustBeneficiaryFailure?: any;
  editCharityBeneficiary?: any;
  editCharityBeneficiaryResponse?: any;
  editCharityBeneficiaryFailure?: any;
  editIndividualBeneficiary?: any;
  editIndividualBeneficiaryResponse?: any;
  editIndividualBeneficiaryFailure?: any;
  editTrustBeneficiary?: any;
  editTrustBeneficiaryResponse?: any;
  editTrustBeneficiaryFailure?: any;
  loadBeneficiary?: any;
  loadBeneficiaryResponse?: any;
  loadBeneficiaryFailure?: any;
}

export const initialState: BeneficiariesState = {
  loadBeneficiaries: undefined,
  loadBeneficiariesResponse: undefined,
  loadBeneficiariesFailure: undefined,
  loadBeneficiary: undefined,
  loadBeneficiaryResponse: undefined,
  loadBeneficiaryFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadBeneficiaries, (state, action) => ({
    ...state,
    loadBeneficiaries: action.request
  })),
  on(actions.loadBeneficiariesSuccess, (state, action) => ({
    ...state,
    loadBeneficiariesResponse: action.response
  })),
  on(actions.loadBeneficiariesFailure, (state, action) => ({
    ...state,
    loadBeneficiariesFailure: action.error
  })),
  on(actions.deleteCharityBeneficiary, (state, action) => ({
    ...state,
    deleteCharityBeneficiary: action
  })),
  on(actions.deleteCharityBeneficiarySuccess, (state, action) => ({
    ...state,
    deleteCharityBeneficiaryResponse: action.response
  })),
  on(actions.deleteCharityBeneficiaryFailure, (state, action) => ({
    ...state,
    deleteCharityBeneficiaryFailure: action.error
  })),
  on(actions.deleteIndividualBeneficiary, (state, action) => ({
    ...state,
    deleteIndividualBeneficiary: action
  })),
  on(actions.deleteIndividualBeneficiarySuccess, (state, action) => ({
    ...state,
    deleteIndividualBeneficiaryResponse: action.response
  })),
  on(actions.deleteIndividualBeneficiaryFailure, (state, action) => ({
    ...state,
    deleteIndividualBeneficiaryFailure: action.error
  })),
  on(actions.deleteTrustBeneficiary, (state, action) => ({
    ...state,
    deleteTrustBeneficiary: action
  })),
  on(actions.deleteTrustBeneficiarySuccess, (state, action) => ({
    ...state,
    deleteTrustBeneficiaryResponse: action.response
  })),
  on(actions.deleteTrustBeneficiaryFailure, (state, action) => ({
    ...state,
    deleteTrustBeneficiaryFailure: action.error
  })),
  on(actions.editCharityBeneficiary, (state, action) => ({
    ...state,
    editCharityBeneficiary: action
  })),
  on(actions.editCharityBeneficiarySuccess, (state, action) => ({
    ...state,
    editCharityBeneficiaryResponse: action.response
  })),
  on(actions.editCharityBeneficiaryFailure, (state, action) => ({
    ...state,
    editCharityBeneficiaryFailure: action.error
  })),
  on(actions.editIndividualBeneficiary, (state, action) => ({
    ...state,
    editIndividualBeneficiary: action
  })),
  on(actions.editIndividualBeneficiarySuccess, (state, action) => ({
    ...state,
    editIndividualBeneficiaryResponse: action.response
  })),
  on(actions.editIndividualBeneficiaryFailure, (state, action) => ({
    ...state,
    editIndividualBeneficiaryFailure: action.error
  })),
  on(actions.editTrustBeneficiary, (state, action) => ({
    ...state,
    editTrustBeneficiary: action
  })),
  on(actions.editTrustBeneficiarySuccess, (state, action) => ({
    ...state,
    editTrustBeneficiaryResponse: action.response
  })),
  on(actions.editTrustBeneficiaryFailure, (state, action) => ({
    ...state,
    editTrustBeneficiaryFailure: action.error
  })),
  on(actions.loadBeneficiary, (state, action) => ({
    ...state,
    loadBeneficiary: { customerId: action.customerId, beneficiaryId: action.beneficiaryId },
    loadBeneficiaryResponse: undefined,
    loadBeneficiaryFailure: undefined
  })),
  on(actions.loadBeneficiarySuccess, (state, action) => ({
    ...state,
    loadBeneficiaryResponse: action.response
  })),
  on(actions.loadBeneficiaryFailure, (state, action) => ({
    ...state,
    loadBeneficiaryFailure: action.error
  })),
);

export const getBeneficiaries = (state: BeneficiariesState) => state.loadBeneficiariesResponse;
export const getBeneficiary = (state: BeneficiariesState) => state.loadBeneficiaryResponse;
